import React, { lazy } from 'react'

import MyCoursePlaceholder from 'src/pages/MyCourse/MyCoursePlaceholder'
import MyCourseHeaderPlaceholder from 'src/pages/MyCourse/subcomponents/MyCourseHeader/MyCourseHeaderPlaceholder'
import PageStickyHeader from 'src/ui/PageStickyHeader/PageStickyHeader'
import LoadPage from 'src/ui/LoadPage/LoadPage'

const MyCourseLazy = lazy(() =>
  import(/* webpackChunkName: "MyCourseLazy" */ './MyCourseLazy')
)

const LoadPageMyCourse = (props) => {
  return (
    <LoadPage
      LazyPage={MyCourseLazy}
      Placeholder={MyCoursePlaceholder}
      headerSection={
        <PageStickyHeader>
          <MyCourseHeaderPlaceholder />
        </PageStickyHeader>
      }
      showBreadcrumbs={false}
      showProductTour
      {...props}
    />
  )
}

export default LoadPageMyCourse
